import axios from '../http'
import {API} from "../const"

const api = API+'/c-p/';

export function genBuySkuInfo(data) {
    return axios.post(api + 'gen-buy-sku-info', data)
}

export function listOptions(params){
    return axios.get(api+"list-options", {params})
}

export function getInfo(id){
    return axios.get(api+id+"/info")
}